import { forwardRef, useEffect, useState } from "react";
import { Button, FormHelperText, Grid, TextField } from "@mui/material";
import { Typography } from "@mui/material";
import RadioAnswer from "../../../components/shared/radioAnswer/RadioAnswer";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const InputRadio = forwardRef(
  (
    {
      data,
      currentQuestion,
      scrollToQuestion,
      latestQuestion,
      handlePayload,
      value,
      isEdit,
      latestStepQuestion,
      handleCost,
      handelRequiredQuestion,
    },
    ref
  ) => {


    const { t } = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)");
    const [errorText, setErrorText] = useState(false);
    const [text, setText] = useState(null);

    const nextQuestionHandler = (height, value) => {
      handlePayload(data, value);
      scrollToQuestion(data, height, value);
      setErrorText(false)

      if (value == "i_dont_know_the_cost") {
        setText("");
      }
    };

    const handleError = () => {
      setErrorText(true);
    };

    useEffect(() => {
      if (value === "i_dont_know_the_cost") {
        setText(0);
      } else if (value !== "i_dont_know_the_cost" && value !== 0) {
        setText(value);
      }
    }, [data, value]);
    
    return (
      <div style={{ padding: isMobile ? "100px 0px" : "100px 20px" }} ref={ref}>
        <>
          <Typography variant="subtitle1">{t(data.question)}</Typography>
          <Grid container spacing={4} alignItems="center">
            {data?.choises.map((choise, index) => (
              <>
                <Grid item xs={9} key={`radio${index}`}>
                  <RadioAnswer
                    title={t(choise.value)}
                    id={choise.id}
                    checked={
                      value === 0
                        ? choise.value === "i_dont_know_the_cost"
                        : value && value !== 0
                          ? choise.value === "i_know_the_cost"
                          : choise.value === value
                    }
                    value={value}
                    handelRequiredQuestion={handelRequiredQuestion}
                    nextQuestionHandler={(value) => {
                      choise.value === "i_know_the_cost"
                        ? handleCost("i_know_the_cost", data.id)
                        : nextQuestionHandler(ref.current.clientHeight, 0);
                    }}
                    lastStepQuestion={data.lastStepQuestion}
                  />
                </Grid>
                {choise.value !== "i_dont_know_the_cost" && value !== 0 && (
                  <Grid item xs={3}>
                    <TextField
                      id="outlined-basic"
                      placeholder={t("cost")}
                      type="number"
                      variant="outlined"
                      fullWidth
                      value={text === null ? "" : String(text).replace(/^0+/, "") }
                      error={errorText}
                      helperText={errorText && t("required_field")}
                      InputProps={{
                        inputProps: { min: 1 },
                        sx: {
                          '& input[type=number]': {
                            MozAppearance: 'textfield',
                            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                              display: 'none',
                            },
                          },
                        },
                      }}

                      onChange={(e) => {
                        const value = e.target.value
                       if(Number(value) > 0 && value !== "0"){
                        setText(Number(value));
                        setErrorText(false);
                       }else{
                        setText(null);
                        setErrorText(true);

                       }
                      }}
                    />
                  </Grid>
                )}
              </>
            ))}
          </Grid>

          {currentQuestion === data.id &&
            currentQuestion !== latestQuestion &&
            !(isEdit && latestStepQuestion === data.id) || (value !== 0 && value !== text) ? (
            <>
              {" "}
              {/* <br></br> */}
              <Button
                onClick={(option) => {
                  value === "i_know_the_cost" && (text === "" || text === "i_know_the_cost")
                    ? handleError()
                    : nextQuestionHandler(ref.current.clientHeight, value === 0 ? value : text);
                }}
                style={{ height: "50px", marginTop: "20px" }}
                color="secondary"
                variant="contained"
                fullWidth
                disabled={!text}
              >
                {t("next")}
              </Button>
            </>
          ) : (
            <></>
          )}
        </>
      </div>
    );
  }
);

export default InputRadio;
